<template>
  <el-dialog top="300px" class="logout-layer" :before-close="handleClose" :visible.sync="shown">
    <div slot="title" class="el-dialog__title">
      <div class="title-left"></div>{{$t('task.friendly')}}<div class="title-right"></div>
    </div>
    <div class="logout-layer-wrap">
      <div class="logout-layer-content">{{$t('task.logOff')}}</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{$t('myTaskV2.cancel')}}</el-button>
      <el-button type="primary" @click="() => handleSure()">{{$t('myTaskV2.sure')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { logoutAjax } from '@/services/loginRegister'
import { clearCookies } from '@/services/common'

export default {
  name: 'Logout',
  props: ['shown'],
  data() {
    return {
      CAS_ENABLE: CAS_ENABLE
    }
  },
  methods: {
    //关闭弹出
    handleClose() {
      this.$emit('handleCancel');
    },
    //确定退出
    handleSure() {
      let self = this;
      if (this.CAS_ENABLE) {
        localStorage.removeItem('myHeaderUser');
        localStorage.removeItem('myUser');
        let callback = encodeURIComponent(`${window.location.origin}/logout?client_name=${CAS_CLIENT_NAME}`);
        window.location.href = `${CAS_LOGOUT_URL}?service=${callback}`;
        clearCookies();
        localStorage.clear();
        sessionStorage.clear();
      } else {
        logoutAjax(Object()).then(function (resp) {
          if (resp.status === 200 && resp.success) {
            clearCookies();
            localStorage.clear();
            // localStorage.removeItem('userInfo');
            // localStorage.removeItem('myUser');
            // localStorage.removeItem('companyCode');
            // localStorage.removeItem('myCompanyCode');
            // localStorage.removeItem('theme');
            // localStorage.removeItem('activeLang');
            sessionStorage.clear();
            self.$router.push({ name: 'login' });
          }
        });
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>
